import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../UI/Button/CustomButtonGreen";
import { Container } from "./ColdStartButtonStyles";
import { coldTrainModel, trainModel } from "../../../../../redux/slices/models";
import { detectPatternsForUnsavedModel } from "../../../../../redux/slices/detectedPatterns";
import { setTrained } from "../../../../../redux/slices/toolbar";
import { removeSelected } from "../../../../../redux/slices/coldStart";
import { selectTotalSPatterns } from "../../../../../redux/slices/selectedPatterns";
import { selectTotalSDPatterns } from "../../../../../redux/slices/selectedDetectedPatterns";
import { selectTotalColdStartPatterns } from "../../../../../redux/slices/coldStart";
import useAuth from "../../../../../auth/hooks/useAuth";

export default function ColdStartButton({ noPatterns }) {
  const isAuth = useAuth();

  const dispatch = useDispatch();

  // Select from redux store
  const training = useSelector(({ models }) => models.training);
  const detectingPatterns = useSelector(
    ({ detectedPatterns }) => detectedPatterns.fetching
  );
  const data = useSelector(({ coldStart }) => coldStart.currentShape);

  const selectedPatternsNumber = useSelector(selectTotalSPatterns);
  const trainableDetectedPatternsNumber = useSelector(selectTotalSDPatterns);
  const drawnCount = useSelector(selectTotalColdStartPatterns);

  const selectedCount =
    selectedPatternsNumber + trainableDetectedPatternsNumber;

  const disabled = data.length < 4;

  const onTrain = async () => {
    if (drawnCount) {
      await dispatch(coldTrainModel(drawnCount, isAuth));
    } else {
      await dispatch(trainModel(selectedCount));
    }
    await dispatch(detectPatternsForUnsavedModel(null, 20));
    dispatch(setTrained(true));
    dispatch(removeSelected());
  };
  return (
    <Container>
      <Button
        disabled={disabled || training || detectingPatterns || noPatterns}
        onClick={onTrain}
      >
        Detect Patterns
      </Button>
    </Container>
  );
}
